// @ts-expect-error not migrated yet
import { currentProjectVersion } from 'hubspot.bender';
import memoizeOne from 'react-utils/memoizeOne';
function isBranchPreview() {
  return Boolean(currentProjectVersion.match(/^static-\d+-[^.]+\.\d+$/));
}

// Cache this since this shouldn't change at all
export default memoizeOne(isBranchPreview);